import { Component, Input } from "@angular/core";
import { Discussion } from "../../../../models";

@Component({
  selector: "invite-to-discussion-button",
  templateUrl: "./invite-to-discussion-button.component.html",
  styleUrls: [
    "./invite-to-discussion-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteToDiscussionButtonComponent {
  @Input() discussion: Discussion;
  @Input() canModifyDiscussion: boolean;
  constructor() {}
}
